import React from "react";
import { Modal, Button, Upload, Typography } from "antd";
import { UploadCloud } from "lucide-react";
import { UploadFile } from "antd/es/upload/interface";
import { RcFile } from "antd/es/upload";

const { Text } = Typography;

interface PhotoFile extends RcFile {
  url?: string;
  preview?: string;
  originFileObj?: RcFile;
}

interface PhotoUploadModalProps {
  visible: boolean;
  photoType: "inventory" | "document" | null;
  fileList: PhotoFile[];
  isUploading: boolean;
  onCancel: () => void;
  onUpload: () => void;
  onUploadChange: (info: any) => void;
  onPreview: (file: UploadFile) => void;
}

const PhotoUploadModal: React.FC<PhotoUploadModalProps> = ({
  visible,
  photoType,
  fileList,
  isUploading,
  onCancel,
  onUpload,
  onUploadChange,
  onPreview,
}) => {
  return (
    <Modal
      title={`Upload ${
        photoType === "inventory" ? "Inventory" : "Document"
      } Photo`}
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={isUploading}
          onClick={onUpload}
          disabled={fileList.length === 0}
        >
          Upload
        </Button>,
      ]}
    >
      <Upload
        listType="picture-card"
        fileList={fileList as UploadFile[]}
        onChange={onUploadChange}
        onPreview={onPreview}
        beforeUpload={() => false}
        accept="image/*"
        multiple
      >
        {fileList.length >= 8 ? null : (
          <div className="flex flex-col items-center">
            <UploadCloud size={20} />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
      </Upload>
      <Text type="secondary">
        Upload up to 8 photos at a time. Supported formats: JPG, PNG, GIF (Max:
        10MB each)
      </Text>
    </Modal>
  );
};

export type { PhotoFile };
export default PhotoUploadModal;
